module.exports = __webpack_public_path__ + "img/impactoI3.dfc31a9c.png";